export default __webpack_public_path__ + "static/media/regulatory--keep-left--g4.0a18f6ba.png";